import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from "dayjs";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
import { debounce } from "lodash";
import ResolveDialog from "./components/ResolveDialog";
import SupplementDialog from "./components/SupplementDialog";
import SupplementRecordDialog from "./components/SupplementRecordDialog";
import { mapActions } from "vuex";
import { apiBaseUrl } from "@/api/service";
export default {
  mixins: [userPopMixin],
  components: {
    ResolveDialog: ResolveDialog,
    SupplementDialog: SupplementDialog,
    SupplementRecordDialog: SupplementRecordDialog
  },
  filters: {
    dateFormat: function dateFormat(value, format) {
      if (!value) return "";
      if (String(value).length === 10) {
        value = value * 1000;
      }
      return dayjs(value).format(format);
    }
  },
  name: "complaint-list",
  data: function data() {
    return {
      fraudId: "17688774732782381",
      sourceMap: {
        1: {
          label: "房源详情",
          url: "/rent-apartment/",
          type: "link"
        },
        2: {
          label: "Lifestyle",
          url: "/community/",
          type: "link",
          flag: "community"
        },
        3: {
          label: "二手",
          url: "/community",
          type: "link",
          flag: "community"
        },
        4: {
          label: "个人主页",
          url: "/index/user/personal?id=",
          type: "link"
        },
        5: {
          label: "IM聊天",
          url: "#/im/chat/record",
          type: "admin",
          flag: "imRecord"
        },
        6: {
          label: "社区详情",
          url: "/community/",
          type: "link",
          flag: "community"
        },
        7: {
          label: "社区评论",
          url: "/community/",
          type: "link",
          flag: "commit"
        },
        8: {
          label: "诈骗消息",
          url: "#/im/chat/record",
          type: "admin",
          flag: "imRecord"
        }
      },
      searchForm: {
        page: 1,
        size: 10,
        complaintTypeId: "",
        complainedUserPhone: "",
        userPhone: "",
        adminId: "",
        status: "",
        id: this.$route.query.id
      },
      // 搜索表单
      adminList: [],
      statusList: [{
        label: "待处理",
        value: "NEW"
      }, {
        label: "跟进中",
        value: "IN_PROGRESS"
      },
      // {
      //     label: "需补充材料",
      //     value: "NEED_SUPPLEMENT",
      // },
      {
        label: "已结案",
        value: "RESOLVED"
      }, {
        label: "搁置",
        value: "SUSPENDED"
      }
      // {
      //     label: "超时自动关闭",
      //     value: "AUTO_CLOSED",
      // },
      ],
      complaintTypeList: [],
      remarkObj: {},
      remarkValue: "",
      remarkDialogVisible: false,
      resolveDialogVisible: false,
      supplementDialogVisible: false,
      supplementRecordDialogVisible: false,
      currentUser: {},
      resolveMode: "edit",
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0
    };
  },
  watch: {
    searchForm: {
      handler: function handler(nVal) {
        if (this.pageDB) {
          this.pageDB.set("searchFormComplaintQuickList", nVal).write();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var data;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this.databasePage({
              user: true
            });
          case 1:
            _this.pageDB = _context.v;
            _context.n = 2;
            return _this.pageDB.value();
          case 2:
            data = _context.v;
            if (data !== null && data !== void 0 && data.searchFormComplaintQuickList) {
              _this.searchForm = _objectSpread(_objectSpread({}, data.searchFormComplaintQuickList), {}, {
                page: 1,
                size: 10
              });
            }
            _this.getData();
            _this.getAdminList();
            _this.getComplaintTypeList();
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/db", ["databasePage", "databasePageClear"])), {}, {
    //跳转关联地址
    toAssociate: function toAssociate(row, type) {
      var _row$complainant, _row$complained;
      var target = row.complaint.target;
      var url = type === 0 ? "#/im/chat/record?userId=".concat((_row$complainant = row.complainant) === null || _row$complainant === void 0 ? void 0 : _row$complainant.userId, "&otherId=").concat((_row$complained = row.complained) === null || _row$complained === void 0 ? void 0 : _row$complained.userId) : "".concat(apiBaseUrl, "/community/").concat(target.extra.postId, "?id=").concat(target.extra.postId);
      window.open(url);
    },
    //搁置
    suspendComplaint: function suspendComplaint(row) {
      var _this2 = this;
      this.$api.suspendComplaint({
        id: row.complaint.id
      }).then(function (res) {
        if (res.data) {
          var _row$complainant2;
          _this2.$message.success("已搁置");
          _this2.getData();
          _this2.$operationLog.push({
            operationType: "complaint",
            code: "shelve",
            detailBatchNo: row.complaint.id,
            userId: (_row$complainant2 = row.complainant) === null || _row$complainant2 === void 0 ? void 0 : _row$complainant2.userId,
            operationOrderType: 'QUICK'
          });
        }
      });
    },
    setInProgress: function setInProgress(row) {
      var _this3 = this;
      this.$api.setInProgress({
        id: row.complaint.id
      }).then(function (res) {
        if (res.data) {
          var _row$complainant3;
          _this3.$message.success("已跟进");
          _this3.$operationLog.push({
            operationType: "complaint",
            code: 'follow_up',
            detailBatchNo: row.complaint.id,
            userId: (_row$complainant3 = row.complainant) === null || _row$complainant3 === void 0 ? void 0 : _row$complainant3.userId,
            operationOrderType: 'QUICK'
          });
          _this3.getData();
        }
      });
    },
    selectComplainedTotal: function selectComplainedTotal(row) {
      this.searchForm = {
        complaintTypeId: '',
        adminId: '',
        statusV2: '',
        page: 1,
        size: 10,
        respondentPhone: ''
      };
      this.searchForm.respondentPhone = row === null || row === void 0 ? void 0 : row.phone;
      this.searchForm.respondentPhone && this.getData();
    },
    //设置已处理弹窗
    toAction: function toAction(id) {
      this.openResolveDialog({
        complaint: {
          id: id
        }
      });
    },
    setStar: debounce(/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        var _row$complaint;
        var res, _row$complaint2, _row$complaint3, _row$complainant4;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.$api.complaintsSetStar({
                id: row.complaint.id,
                flag: !((_row$complaint = row.complaint) !== null && _row$complaint !== void 0 && (_row$complaint = _row$complaint.star) !== null && _row$complaint !== void 0 && _row$complaint.flag),
                level: 1
              });
            case 1:
              res = _context2.v;
              if (res.data) {
                this.$message.success((_row$complaint2 = row.complaint) !== null && _row$complaint2 !== void 0 && (_row$complaint2 = _row$complaint2.star) !== null && _row$complaint2 !== void 0 && _row$complaint2.flag ? "已取消星标" : "已设为星标");
                this.$operationLog.push({
                  operationType: "complaint",
                  code: (_row$complaint3 = row.complaint) !== null && _row$complaint3 !== void 0 && (_row$complaint3 = _row$complaint3.star) !== null && _row$complaint3 !== void 0 && _row$complaint3.flag ? 'remove_star' : 'starred',
                  detailBatchNo: row.complaint.id,
                  userId: (_row$complainant4 = row.complainant) === null || _row$complainant4 === void 0 ? void 0 : _row$complainant4.userId,
                  operationOrderType: 'QUICK'
                });
                this.getData();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), 200),
    goDetail: function goDetail(row) {
      var _row$complaint4 = row.complaint,
        source = _row$complaint4.source,
        sourceObjId = _row$complaint4.sourceObjId,
        target = _row$complaint4.target;
      var sourceObj = this.sourceMap[source];
      if (!(sourceObj !== null && sourceObj !== void 0 && sourceObj.url)) return;
      if (sourceObj.type === "admin") {
        if (sourceObj.flag === "imRecord") {
          var _row$complainant5, _row$complained2;
          window.open("".concat(sourceObj.url, "?userId=").concat((_row$complainant5 = row.complainant) === null || _row$complainant5 === void 0 ? void 0 : _row$complainant5.userId, "&otherId=").concat((_row$complained2 = row.complained) === null || _row$complained2 === void 0 ? void 0 : _row$complained2.userId));
        } else {
          window.open("".concat(sourceObj.url, "?id=").concat(sourceObjId));
        }
        return;
      }
      if (sourceObj.flag === 'community') {
        window.open("".concat(sourceObj.url).concat(sourceObjId, "?id=").concat(sourceObjId));
        return;
      }
      if (sourceObj.flag === 'commit') {
        var _target$extra, _target$extra2;
        window.open("".concat(sourceObj.url).concat(target === null || target === void 0 || (_target$extra = target.extra) === null || _target$extra === void 0 ? void 0 : _target$extra.postId, "?id=").concat(target === null || target === void 0 || (_target$extra2 = target.extra) === null || _target$extra2 === void 0 ? void 0 : _target$extra2.postId));
        return;
      }
      window.open("".concat(sourceObj.url).concat(sourceObjId));
    },
    getStatusType: function getStatusType(row) {
      var label = "";
      var color = "";
      switch (row.complaint.statusV2) {
        case "NEW":
          label = "待处理";
          color = "#2DB6B6";
          break;
        case "IN_PROGRESS":
          label = "跟进中";
          color = "#F3B251";
          break;
        case "NEED_SUPPLEMENT":
          label = "跟进中";
          color = "#F3B251";
          break;
        case "RESOLVED":
          label = "已结案";
          color = "#B7B7B7";
          break;
        case "SUSPENDED":
          label = "搁置";
          color = "#B7B7B7";
          break;
        default:
          label = "";
          color = "#B7B7B7";
          break;
      }
      this.$set(row, "statusLabel", label);
      this.$set(row, "statusColor", color);
    },
    goChatRecord: function goChatRecord(row) {
      if (!row.messageCount) return;
      window.open("#/im/chat/record?userId=".concat(row.complainant.userId, "&otherId=").concat(row.complained.userId));
    },
    // 打开处理对话框
    openResolveDialog: function openResolveDialog(row) {
      var _row$complaint5;
      var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "edit";
      this.currentId = (_row$complaint5 = row.complaint) === null || _row$complaint5 === void 0 ? void 0 : _row$complaint5.id;
      this.resolveMode = mode;
      this.resolveDialogVisible = true;
    },
    // 打开补充材料对话框
    openSupplementDialog: function openSupplementDialog(row) {
      var _row$complaint6;
      this.currentId = (_row$complaint6 = row.complaint) === null || _row$complaint6 === void 0 ? void 0 : _row$complaint6.id;
      this.currentUser = row.complainant || {};
      this.supplementDialogVisible = true;
    },
    // 打开补充材料记录对话框
    openSupplementRecordDialog: function openSupplementRecordDialog(complaint, row) {
      this.currentId = complaint === null || complaint === void 0 ? void 0 : complaint.id;
      row.supplementUnread = false;
      this.supplementRecordDialogVisible = true;
    },
    getComplaintTypeList: function getComplaintTypeList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this4.$api.getComplaintTypeList();
            case 1:
              res = _context3.v;
              _this4.complaintTypeList = res.data;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.page = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (type === "search") {
                _this5.searchForm.page = 1;
              }
              _this5.searchForm.bizType = "QUICK";
              _this5.tableLoading = true;
              _context4.n = 1;
              return _this5.$api.getComplaintList(_this5.searchForm);
            case 1:
              res = _context4.v;
              _this5.tableData = res.data.content;
              _this5.total = res.data.totalSize;
              _this5.tableLoading = false;
              _this5.getUserScoreList(_this5.tableData);
              _this5.tableData = _this5.tableData.map(function (item) {
                var _item$complainant, _item$complained;
                _this5.getStatusType(item);
                return _objectSpread(_objectSpread({}, item), {}, {
                  userId: (item === null || item === void 0 || (_item$complainant = item.complainant) === null || _item$complainant === void 0 ? void 0 : _item$complainant.userId) || "",
                  otherId: (item === null || item === void 0 || (_item$complained = item.complained) === null || _item$complained === void 0 ? void 0 : _item$complained.userId) || ""
                });
              });
              _this5.getUserListByIds(_this5.tableData, "userId", "otherId");
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    //根据用户id获取雷达图信息
    getUserScoreList: function getUserScoreList(data) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var userIds, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              userIds = [];
              data.forEach(function (item) {
                if (item.complainant.userId || item.complained.userId) {
                  var userType = item.complainant.userType;
                  var complainedUserType = item.complained.userType;
                  if (!userType) userIds.push(item.complainant.userId);
                  if (!complainedUserType) userIds.push(item.complained.userId);
                }
              });
              userIds = _toConsumableArray(new Set(userIds));
              _context5.n = 1;
              return _this6.$api.queryUserScoreById({
                userIds: userIds
              });
            case 1:
              res = _context5.v;
              if (res && res.data.length) {
                _this6.tableData.forEach(function (item) {
                  var userScore = res.data.find(function (score) {
                    return score.userId === item.complainant.userId;
                  });
                  var complainedUserScore = res.data.find(function (score) {
                    return score.userId === item.complained.userId;
                  });
                  _this6.$set(item.complainant, "userScore", userScore || {});
                  _this6.$set(item.complained, "userScore", complainedUserScore || {});
                });
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    getAdminList: function getAdminList() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this7.$api.getAdminUser({
                type: "all"
              });
            case 1:
              res = _context6.v;
              _this7.adminList = res.data;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    setComplaintStatus: function setComplaintStatus(id, status, user) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return _this8.$api.setComplaintStatus({
                id: id,
                status: status
              });
            case 1:
              _this8.$message.success("操作成功");
              _this8.getData();

              // 操作上报
              _this8.$operationLog.push({
                code: status == 1 ? "shelve" : "resolved",
                userId: user.userId,
                operationType: "complain",
                detailBatchNo: id,
                operationOrderType: 'QUICK'
              });
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    issueReward: function issueReward(id, user) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return _this9.$api.complaintIssueReward({
                id: id
              });
            case 1:
              _this9.$message.success("操作成功");
              _this9.getData();

              // 操作上报
              _this9.$operationLog.push({
                code: "reward",
                userId: user.userId,
                operationType: "complain",
                detailBatchNo: id,
                operationOrderType: 'QUICK'
              });
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    }
  })
};